import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AccordionModule } from "primeng/accordion";
import { CheckboxModule } from "primeng/checkbox";
import { BiAccordionComponent } from "./bi-accordion.component";

@NgModule({
  declarations: [BiAccordionComponent],
  imports: [CommonModule, FormsModule, CheckboxModule, AccordionModule],
  exports: [BiAccordionComponent]
})
export class BiAccordionModule {}
